module.exports = __webpack_public_path__ + "static/img/lv1.ee487d40.png";